import { render, staticRenderFns } from "./new-transport.vue?vue&type=template&id=8c83916c"
import script from "./new-transport.js?vue&type=script&lang=js&external"
export * from "./new-transport.js?vue&type=script&lang=js&external"
import style0 from "./new-transport.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports